<template>
  <div class="flex flex-wrap gap-2" role="group" aria-label="Filter projects">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="rounded-full border px-4 py-2 text-sm font-medium transition-colors duration-200"
      :class="modelValue === option.value
        ? 'border-accent bg-accent text-white'
        : 'border-gray-200 bg-secondary-light text-primary-dark hover:border-accent hover:text-accent dark:border-secondary-dark dark:bg-ternary-dark dark:text-ternary-light'"
      :aria-pressed="modelValue === option.value"
      @click="emit('update:modelValue', option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script setup lang="ts">
import type { ProjectType } from '~/utils/projects'
import { PROJECT_TYPE_LABELS } from '~/utils/projects'

defineProps<{ modelValue: ProjectType | '' }>()
const emit = defineEmits<{ 'update:modelValue': [value: ProjectType | ''] }>()

const options = [
  { value: '' as const, label: 'All' },
  ...Object.entries(PROJECT_TYPE_LABELS).map(([value, label]) => ({ value: value as ProjectType, label })),
]
</script>
